import 'floating-vue/dist/style.css';

import { VTooltip } from 'floating-vue';

import { TOOLTIP_DEFAULT_OPTIONS } from './config';

const { options } = VTooltip;

VTooltip.options = { ...options, ...TOOLTIP_DEFAULT_OPTIONS };

export const dpTooltip = VTooltip;

export default dpTooltip;
